export const ENVIRONMENTS = {
  GLOBAL: 'gcp',
  CHINA: 'azure',
}

export const EnvironmentConfig = {
  env: process.env.REACT_APP_ENVIRONMENT || "non-specified"
}
